import { Contact } from "../../../../src/components/Contact.tsx";
import SectionHeader from "../../../../src/components/Layout/SectionHeader";
import * as React from 'react';
export default {
  Contact,
  SectionHeader,
  React
};